import { message, Button } from 'antd';

export const AlertType = Object.freeze({
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
});

export const alert = (type, content, autoClose = true, duration = 4) => {
    const key = `alert-${Date.now()}`;
    const displayDuration = autoClose ? duration : 0;

    const handleClose = () => message.destroy(key);

    // Hide AntD default icon
    if (!autoClose) {
        const style = document.createElement('style');
        style.innerHTML = `
            .ant-message-notice-content .ant-message-custom-content.ant-message-${type} > .anticon {
                display: none !important;
            }
        `;
        document.head.appendChild(style);
    }

    const closableContent = (
        <div
            key={key}
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '12px',
                textAlign: 'left',
                width: '100%',
                fontSize: '14px',
                lineHeight: '1.4',
            }}
        >
            <div
                style={{
                    flex: '1 1 auto',
                    wordBreak: 'break-word',
                }}
            >
                {content}
            </div>

            <div
                style={{
                    alignSelf: 'flex-end',
                    marginLeft: 'auto',
                }}
            >
                <Button
                    size="small"
                    type="primary"
                    danger={type === AlertType.ERROR}
                    onClick={handleClose}
                >
                    Close
                </Button>
            </div>
        </div>
    );

    message.open({
        key,
        type,
        content: autoClose ? content : closableContent,
        duration: displayDuration,
    });
};
